import { Navigate, Outlet } from "react-router-dom";
import { Navbar } from "./common/Navbar";
import { isLoggedIn } from "../utils/auth";

export default function LoggedInRoute() {
  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }
  return (<>
    <Navbar />
    <Outlet />
  </>);
}